import React from 'react';
import styled from 'styled-components';
import ActivationSteps from './ActivationSteps';
import { Trans, useTranslation } from 'react-i18next';
import { themeColor } from '../../Theming';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const ButtonsContainer = styled.div`
  padding-top: 10px;
  padding-inline: 30px;
  display: flex;
  flex-direction: column;

  & > button {
    background-color: ${themeColor('navyBlueText')};
    height: 56px;
    margin-top: 20px;
    border-radius: 100px;
    color: ${themeColor('white')};
    font-size: 16px;
    font-weight: 700;
    font-family: Helvetica;
    border: none;

    &:last-child {
      background-color: ${themeColor('white')};
      color: ${themeColor('navyBlueText')};
      border: 1px solid ${themeColor('navyBlueText')};
    }
  }
`;

interface ActivateNowProps {
  title?: string;
  msg?: string;
  steps?: string[];
  navigateToSettings?: () => void;
  close?: () => void;
}

const ActivateNow: React.FC<ActivateNowProps> = ({
  title,
  msg,
  steps,
  navigateToSettings,
  close,
}) => {
  const { t } = useTranslation();

  return (
    <Container>
      <ActivationSteps title={title} msg={msg} steps={steps} />

      <ButtonsContainer>
        <button
          id="android-accessiblity-button-agree"
          onClick={navigateToSettings}
          aria-label="Agree to Accessibility permissions"
        >
          {t('eon.agree')}
        </button>
        <button
          onClick={close}
          id="android-accessiblity-button-disagree"
          aria-label="Disagree to Accessibility permissions"
        >
          {t('eon.disagree')}
        </button>
      </ButtonsContainer>
    </Container>
  );
};

export default ActivateNow;
